export default "__VITE_ASSET__D011z1hi__"